import {z} from 'zod';

export const FinancialProductTypeSchema = z.enum(['STANDARD', 'BALLOON', 'LEASING']);
export type FinancialProductType = z.infer<typeof FinancialProductTypeSchema>;
